import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getPlanList } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class packages extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              package_list: []
        };
        this.packageList();
    }


    packageList = async () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        path: window.location.pathname,
      });
      const res = await getPlanList(ins);
      if (res.status == 1) {
        this.setState({
          package_list: res.list
        });
        
      }
    };


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }



    render() {

        const { package_list } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Packages</h4>
                 
                  
                  <div class="float-right"><button class="btn btn-primary btn-sm" onClick={this.openAdd}>Add New</button></div>


                  <div class="table-responsive pt-3">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          
                           <th>
                            <strong>Plan name</strong>
                          </th>

                           <th>
                            <strong>Price(INR)</strong>
                          </th>

                          <th>
                            <strong>Type</strong>
                          </th>
                                                   
                          <th>
                            <strong>Action</strong>
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                      {package_list.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          
                          <td>
                           {item.plan_name}
                          </td>

                           <td>
                           {item.plan_price}
                          </td>

                           <td>
                           {item.plan_type}
                          </td>
                                           
                          <td dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>

                

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default packages;


// WEBPACK FOOTER //
// ./src/components/bewise/adminPackages.jsx